/*========================================================================
 * $Id: tabs.js 88584 2016-02-03 12:46:52Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


define([
    "i18n/i18n",
    "backbone",
    "underscore"
  ], function (
    i18n,
    Backbone,
    _
  ) {



 function syncMethod(that, method, model, options) {
    // his.options.
    // two callbacks
    // options.success: resp, status, xhr
    // options.error: xhr, status, thrown
    var request = { appid : this.appid} ;
    // var that = this;
    switch (method) {
      case 'create':
      case 'update': {
        // request.create ={};

        /*
        if (model instanceof Backbone.Model) {
          // TODO: get id from server.
          request.create = _.clone(model.attributes;
          request.create.id = model.collection.models.length;
          request.create.request = model.attributes;
        }
        */

        request[method] = model.toJSON(options);
        // console.log(method, "model->json", request[method]);
        if (this.usePaths && !request[method].path) {
          request[method].path = this.path;
        }

        function onResponseCreateOrUpdate(response, channel, observer, computing) {
          // console.log("received response", JSON.stringify(response, null,1 ));
          if (options.success) {
            // if (model instanceof Backbone.Model)
            var responseAttributes = that.parse(response) && that.parse(response)[0];
            options.success(responseAttributes, 200);
          }
        }

        function onErrorCreateOrUpdate(response, channel) {
          // console.log("received error", JSON.stringify(response, null,1 ));
          if (options.error)
            options.error(null, response);
        }

        var responseObserver = {};

        _.extend(responseObserver, Backbone.Events);

        that.listenTo(responseObserver, "response", onResponseCreateOrUpdate);
        that.listenTo(responseObserver, "error", onErrorCreateOrUpdate);
        // read the complete collection.
        var promise = that.serviceStub.cast(that.channels,
                     request,
                     responseObserver
                     );

        break;
      }
      case 'delete': {
        // request.create ={};

        /*
        if (model instanceof Backbone.Model) {
          // TODO: get id from server.
          request.create = _.clone(model.attributes;
          request.create.id = model.collection.models.length;
          request.create.request = model.attributes;
        }
        */
        request.remove = { id: model.id };

        if (this.usePaths) {
          request.remove  = { path: model.get("path") };
        }

        function onResponseDelete(response, channel, observer, computing) {
          // console.log("received response", JSON.stringify(response, null,1 ));
          if (options.success) {
            // if (model instanceof Backbone.Model)
            // var responseAttributes = that.parse(response)[0];
            options.success({}, 200);
          }
        }

        function onErrorDelete(response, channel) {
          // console.log("received error", JSON.stringify(response, null,1 ));
          if (options.error)
            options.error(null, response);
        }

        var responseObserver = {};

        _.extend(responseObserver, Backbone.Events);

        that.listenTo(responseObserver, "response", onResponseDelete);
        that.listenTo(responseObserver, "error", onErrorDelete);
        // read the complete collection.
        var promise = that.serviceStub.cast(that.channels,
                     request,
                     responseObserver
                     );

        break;
      }
      case 'read':  {

        request.read = { };

        if (this.path) request.read.path = this.path;
        if (this.property) request.read.property = this.property;
        if (this.owner) request.read.owner = this.owner;

        if (model instanceof Backbone.Model) {
          request.read.id = model.id;
        }

        function onResponseRead(response, channel, observer, computing) {
          // console.log("received response", JSON.stringify(response, null,1 ));
          if (options.success)
            options.success(response, 200);
        }

        function onErrorRead(response, channel) {
          // console.log("received error", JSON.stringify(response, null,1 ));
          if (options.error)
            options.error(null, response);
        }

        var responseObserver = {};

        _.extend(responseObserver, Backbone.Events);

        that.listenTo(responseObserver, "response", onResponseRead);
        that.listenTo(responseObserver, "error", onErrorRead);
        // TODO Merge multiple sources for persisted queries.
        var promise = that.serviceStub.cast(that.channels,
                     request,
                     responseObserver
                     );

        // TOOD: this stoplisteningto resposneObserver.

        break;
      }
      case 'list_resources':  {
        
        request.list_resources = { };

        if (this.path) request.list_resources.path = this.path;
        if (this.filter) request.list_resources.filter = this.filter;
        if (this.distinct_properties) request.list_resources.distinct_properties = this.distinct_properties;
        if (this.order_by) request.list_resources.order_by = this.order_by;

        if (model instanceof Backbone.Model) {
          request.list_resources.id = model.id;
        }

        function onResponseRead(response, channel, observer, computing) {
          // console.log("received response", JSON.stringify(response, null,1 ));
          if (options.success)
            options.success(response, 200);
        }

        function onErrorRead(response, channel) {
          // console.log("received error", JSON.stringify(response, null,1 ));
          if (options.error)
            options.error(null, response);
        }

        var responseObserver = {};

        _.extend(responseObserver, Backbone.Events);

        that.listenTo(responseObserver, "response", onResponseRead);
        that.listenTo(responseObserver, "error", onErrorRead);
        // TODO Merge multiple sources for persisted queries.
        var promise = that.serviceStub.cast(that.channels,
                     request,
                     responseObserver
                     );

        // TOOD: this stoplisteningto resposneObserver.

        break;
      }
      default:
        throw new Error("PersistedCollection: Unsupported operation " + method + "!");
    }
  }


var PersistedModel = Backbone.Model.extend({
  initialize: function(atts, options) {
    this.channels = options.channels;
    this.serviceStub = options.serviceStub;
    this.appid = options.appid;
    this.syncMethod = _.bind(syncMethod, this, this);
    // optional if we want to automatically persist events.
    if (options.parse && _.isFunction(options.parse)) {
      this.parse = options.parse;
    }
  },
  sync: function(/* method, model, options*/) {
    return this.syncMethod.apply(this, arguments);
  }

});

var PersistedCollection = Backbone.Collection.extend({

  _prepareModel: function(attrs, options) {
     var model = Backbone.Collection.prototype._prepareModel.apply(this, arguments);
     // patch the sync method of the model.
     model.sync = this.syncMethod;
     return model;
  },

  initialize: function(models, options) {
    // Backbone.Collection.initialize.apply(this, arguments);
    this.channels = options.channels;
    this.serviceStub = options.serviceStub;
    this.appid = options.appid;
    this.syncMethod = _.bind(syncMethod, this, this);
    // optional if we want to automatically persist events.
    this.listenTo(this, "add", this.saveModel);
    this.listenTo(this, "update", this.saveModel);
    this.listenTo(this, "remove", this.destroyModel);
    if (options.parse && _.isFunction(options.parse)) {
      this.parse = options.parse;
    }
  },

  saveModel: function(model, collection, options) {
    model.save(null, options);
    this.trigger("change");
  },

  destroyModel: function(model, collection) {
    model.destroy();
    this.trigger("change");
  },

  sync: function() {
    return this.syncMethod.apply(this, arguments);
  }


});

PersistedCollection.Model = PersistedModel;

return PersistedCollection;

});
